import { QuestionnaireCategoryConnectionInput } from '@/models/gen/graphql';

import { SearchQuestionnaireCategoryDocument } from '@/api/queries';
import graphApi from '@/api';
import { queryInput } from '@/utils';

type SearchQuestionnaireCategoriesFilters = {
  name?: string;
  roleId?: string;
};

const [, runRefetchQuestionnaireCategory] = graphApi(SearchQuestionnaireCategoryDocument);
const PAGE_SIZE = 1000;

export const searchCategories = async (filters?: SearchQuestionnaireCategoriesFilters) => {
  const input: QuestionnaireCategoryConnectionInput = {
    first: PAGE_SIZE,
    after: null,
    query: filters
      ? [
          {
            name: filters?.name ? queryInput(filters.name) : undefined,
            roleId: filters?.roleId ? queryInput(filters.roleId) : undefined,
            active: queryInput(1),
          },
        ]
      : [],
  };

  return await runRefetchQuestionnaireCategory({ input });
};

export const searchCategoriesWithMetadata = async (filters?: SearchQuestionnaireCategoriesFilters) => {
  const res = await searchCategories(filters);

  return {
    categories: res?.searchQuestionnaireCategory?.questionnaireCategoryConnection?.edges
      ?.map((edge) => edge?.node)
      .filter((node) => Boolean(node)),
    totalCount: res?.searchQuestionnaireCategory?.questionnaireCategoryConnection?.totalCount,
  };
};
